import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthComponent } from './auth.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthContainer } from './auth.container';
import { RouterLink, RouterOutlet } from '@angular/router';

@NgModule({
    declarations: [
        AuthContainer,
        AuthComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterOutlet,
        RouterLink
    ]
})

export class AuthModule {}
